import { translate } from '../../i18n/translate';
import { describeLine } from '../../utils/productLabel';

const englishT = (key, vars) => translate(null, key, vars);

export const STATUS = {
  paid: { label: 'Paid', bg: 'bg-[#dcfce7]', text: 'text-[#15803d]' },
  partial: { label: 'Partially paid', bg: 'bg-[#fef3c7]', text: 'text-[#b45309]' },
  open: { label: 'Open', bg: 'bg-[#e6f1ff]', text: 'text-[#0069c4]' },
  overdue: { label: 'Overdue', bg: 'bg-[#fee2e2]', text: 'text-[#dc2626]' },
  void: { label: 'Voided', bg: 'bg-[#f1f5f9]', text: 'text-[#64748b]' },
  pending: { label: 'Pending', bg: 'bg-[#fef9c3]', text: 'text-[#a16207]' },
  processing: { label: 'Processing', bg: 'bg-[#e0e7ff]', text: 'text-[#4338ca]' },
  failed: { label: 'Failed', bg: 'bg-[#ffedd5]', text: 'text-[#c2410c]' },
  needs_attention: { label: 'Needs Attention', bg: 'bg-[#f3e8ff]', text: 'text-[#7e22ce]' },
};

export const PAYMENT_STATUS = {
  recorded: { label: 'Paid', bg: 'bg-[#dcfce7]', text: 'text-[#15803d]' },
  initiated: { label: 'Processing', bg: 'bg-[#e0e7ff]', text: 'text-[#4338ca]' },
  unknown: { label: 'Confirming with Intuit', bg: 'bg-[#fef3c7]', text: 'text-[#b45309]' },
  paid_unrecorded: {
    label: 'Paid - not in QuickBooks yet',
    bg: 'bg-[#fef9c3]',
    text: 'text-[#a16207]',
  },
  declined: { label: 'Declined', bg: 'bg-[#ffe4e6]', text: 'text-[#be123c]' },
  failed: { label: 'Failed', bg: 'bg-[#ffedd5]', text: 'text-[#c2410c]' },
  returned: { label: 'Returned', bg: 'bg-[#fee2e2]', text: 'text-[#dc2626]' },
};

export function amountBreakdown(inv, t = englishT) {
  if (!Array.isArray(inv?.lines) || inv.lines.length === 0) return '';
  const numeric = (value) =>
    (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) &&
    Number.isFinite(Number(value))
      ? Number(value)
      : null;
  return inv.lines
    .filter(Boolean)
    .map((line) => {
      if (inv.source === 'app' || line.units != null || line.orderQuantity != null) {
        const label = describeLine(line.name || line.sku || t('item'), line.size);
        const units = numeric(line.units != null ? line.units : line.quantity);
        const count = numeric(line.orderQuantity);
        const price = numeric(line.unitPrice);
        const facts = [
          count != null ? t(count === 1 ? '{count} item' : '{count} items', { count }) : '',
          units != null ? t('{units} units', { units }) : '',
        ]
          .filter(Boolean)
          .join('; ');
        const rate =
          price != null ? `@ ${t('{price}/unit', { price: `$${price.toFixed(2)}` })}` : '';
        const detail = [facts, rate].filter(Boolean).join(' ');
        return detail ? `${label}: ${detail}` : label;
      }
      const label = line.description || line.name || t('item');
      const qty = line.quantity != null ? `${line.quantity} x ` : '';
      const amount = line.amount != null ? ` = $${Number(line.amount).toFixed(2)}` : '';
      return `${label}: ${qty}${line.unitPrice != null ? `$${Number(line.unitPrice).toFixed(2)}` : ''}${amount}`;
    })
    .join('\n');
}

export const qbDay = (value) =>
  value ? new Date(value).toLocaleDateString('en-US', { timeZone: 'UTC' }) : '—';

export const TABS = [
  { key: 'all', label: 'All' },
  { key: 'open', label: 'Unpaid' },
  { key: 'overdue', label: 'Overdue' },
  { key: 'partial', label: 'Partially paid' },
  { key: 'paid', label: 'Paid' },
  { key: 'needs_attention', label: 'Needs attention', adminOnly: true },
];

export const PAGE_SIZE = 50;
export const SORT_KEYS = {
  'INVOICE #': 'docNumber',
  CLINIC: 'clinic',
  DATE: 'txnDate',
  DUE: 'dueDate',
  AMOUNT: 'total',
  BALANCE: 'balance',
  STATUS: 'status',
};
export const SORT_DEFAULT_DIR = {
  txnDate: 'desc',
  dueDate: 'desc',
  total: 'desc',
  balance: 'desc',
};

export const payable = (invoice) =>
  invoice.source === 'quickbooks' && Number(invoice.balance) > 0 && Boolean(invoice.clinic?._id);

export const pdfAvailable = (invoice) =>
  invoice?.source === 'quickbooks' && typeof invoice._id === 'string' && Boolean(invoice._id);
